import { css } from "react-emotion";

export const navContainer = css`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  align-items: center;
  padding: 5px 10px;
  /* height: 5em; */
  /* box-shadow: rgb(120 120 120 / 50%) 3px 3px 13px; */
  /* border-bottom: 1px solid #acdfe0; */
  box-shadow: inset 0 -1px 0 rgb(100 121 143 / 12%);
  height: 64px;
  z-index: 999;
  color: black;
  background: white;
  /* padding-bottom: 90px; */

  * {
    z-index: 2;
  }
`;

export const childStyle = css`
  a {
    text-decoration: none;
    color: white;
  }
`;

export const rightSide = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
`;

export const appTitle = css`
  max-height: 40px;
  text-align: center;
  width: 100%;
  text-overflow: ellipsis;
  color: #1f3747;
  white-space: nowrap;
  overflow: hidden;
  z-index: 1;
  font-size: 1.1em;
  @media only screen and (min-width: 500px) {
    font-size: 1.6em;
  }
  @media only screen and (min-width: 768px) {
    font-size: 2em;
  }
`;
